import {CellProps, Column, Row} from '@komune-io/g2-layout'
import {Avatar, Typography} from '@mui/material'
import {TFunction} from 'i18next'
import {PlatformTableSearchFilters, PlatformPaginatedTable} from "@tracabois/template";
import {firstPage, OffsetPagination, PageQuery, PageResult} from "@tracabois/utils";
import React from "react";
import {WoodSpecies} from "../../model/WoodSpecies";
import { externalFileUrl } from '@tracabois/domain';

interface WoodSpeciesProps {
  page?: PageResult<WoodSpecies>
  search?: string
  isLoading?: boolean
  onPageQueryChange: (page: PageQuery) => void;
  onRowClicked: (row: Row<WoodSpecies>) => void;
  actions: React.ReactNode
}

export const WoodSpeciesTable = (props: WoodSpeciesProps) => {
  const {page, search, isLoading, onPageQueryChange, onRowClicked, actions} = props

  const onSearch = (search?: string) => {
    onPageQueryChange({
      pagination: page?.pagination || firstPage,
      search: search
    })
  }
  const filter = (
    <PlatformTableSearchFilters actions={actions} onSubmit={(props) => onSearch(props.search)}/>
  )
  const onPaginationChange = (pagination: OffsetPagination) => {
    onPageQueryChange({
      pagination: pagination,
      search: search
    })
  }
  return (
    <PlatformPaginatedTable<WoodSpecies>
      page={page}
      columnsDefinition={getColumns}
      isLoading={isLoading}
      actions={filter}
      onPageChange={onPaginationChange}
      onRowClicked={onRowClicked}
      noElevation
    />
  )
}


const getColumns = (t: TFunction): Column<WoodSpecies>[] => ([{
  Header: `${t("woodSpecies.img", "Image")}`,
  // @ts-ignore
  Cell: ({row}: CellProps<WoodSpecies>) => (
    <Avatar alt={row.original.name} src={externalFileUrl(row.original.img) || ""}/>
  )
}, {
  Header: `${t("woodSpecies.essences", "Essences")}`,
  // @ts-ignore
  Cell: ({row}: CellProps<WoodSpecies>) => (
    <Typography variant="body2">{row.original.name}</Typography>
  )
}])